// import React, { useState, useEffect, useRef } from "react";
// import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
// import CommonReactTable from "../CommonUtils/CommonReactTable";
// import { config } from "../CommonUtils/CommonURLS";
// import { FaCheckCircle } from "react-icons/fa";
// import { Modal } from "react-bootstrap";
// import { useReactToPrint } from "react-to-print";

// export default function NonTeachingFacultyDetailsRepo() {
//   const roleIdValue = sessionStorage.getItem("role_id");
//   const tableRef = useRef(null);

//   const handlePrint = useReactToPrint({
//     contentRef: tableRef,
//     documentTitle: "Non-Teaching Faculty Details",
//   });


//   const [nonTeachingFacultyData, setNonTeachingFacultyData] = useState([]);
//   const [selectedRows, setSelectedRows] = useState({});
//   const [showModal, setShowModal] = useState(false);
//   const [modalData, setModalData] = useState(null);

//   function GetNonTeachingFacultyData() {
//     const url = `${config.url.FAC_URL}getFacultyDetailsnonteaching`;
//     CommonAxiosGet(url).then((res) => {
//       if (res?.data?.scode === "01" && res?.data?.fac_details?.length > 0) {
//         setNonTeachingFacultyData(res?.data?.fac_details);
//       } else {
//         setNonTeachingFacultyData([]);
//       }
//     });
//   }

 

//   const openBasicDetailsModal = (data) => {
//     setModalData(data);
//     setShowModal(true);
//   };

//   const NonTeachingFacultyReportColumns = [
//     {
//       id: "S No",
//       header:
//         roleIdValue === "4" ? (
//           <input
//             type="checkbox"
//             onChange={(e) => {
//               const checked = e.target.checked;
//               const newSelected = {};
//               nonTeachingFacultyData.forEach((row) => {
//                 if (!row.is_checker_approved) newSelected[row.sno] = checked;
//               });
//               setSelectedRows(newSelected);
//             }}
//             checked={nonTeachingFacultyData.filter((r) => !r.is_checker_approved).length > 0 && nonTeachingFacultyData.filter((r) => !r.is_checker_approved).every((r) => selectedRows[r.sno])}
//           />
//         ) : (
//           "S.No"
//         ),
//       cell: ({ row }) => (
//         <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//           {roleIdValue === "4" && !row.original.is_checker_approved && (
//             <input
//               type="checkbox"
//               checked={!!selectedRows[row.original.sno]}
//               onChange={(e) =>
//                 setSelectedRows((prev) => ({
//                   ...prev,
//                   [row.original.sno]: e.target.checked,
//                 }))
//               }
//             />
//           )}
//           <span>{row.index + 1}</span>
//         </div>
//       ),
//     },
//     {
//       id: "cfms_id",
//       header: "CFMS ID",
//       accessorKey: "cfms_id",
//     },
//     {
//       id: "nt_fac_name",
//       header: "Faculty Name",
//       accessorKey: "nt_fac_name",
//       meta: { style: { textAlign: "left" } },
//     },
//     {
//       id: "masked_aadhar",
//       header: "Adhaar No",
//       accessorKey: "masked_aadhar",
//       meta: { style: { textAlign: "left" } },
//     },
//     {
//       id: "gender",
//       header: "Gender",
//       accessorKey: "gender",
//     },
//     {
//       id: "dob",
//       header: "Date of Birth",
//       accessorKey: "dob",
//       cell: ({ getValue }) => {
//         const value = getValue();
//         if (!value) return "";
//         const date = new Date(value);
//         return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
//       },
//     },
//     {
//       id: "nt_designation",
//       header: "Designation",
//       accessorKey: "nt_designation",
//       meta: { style: { textAlign: "left" } },
//     },
//     {
//       id: "doj",
//       header: "Date of Joining in the University",
//       accessorKey: "doj",
//       meta: { style: { textAlign: "left" } },
//       cell: ({ getValue }) => {
//         const value = getValue();
//         if (!value) return "";
//         const date = new Date(value);
//         return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
//       },
//     },
//     {
//       id: "nt_unv_type",
//       header: "University Type",
//       accessorKey: "nt_unv_type",
//       meta: { style: { textAlign: "left" } },
//     },
//     {
//       id: "appoint_cat_name",
//       header: "Appointed Category",
//       accessorKey: "appoint_cat_name",
//       meta: { style: { textAlign: "left" } },
//     },
//     {
//       id: "nt_design_time_of_appointment",
//       header: "Designation at the time of Appointment",
//       accessorKey: "nt_design_time_of_appointment",
//       meta: { style: { textAlign: "left" } },
//     },
//     {
//       id: "qualification_appoint_name",
//       header: "Qualifications at the Time of Appointment",
//       accessorKey: "qualification_appoint_name",
//       meta: { style: { textAlign: "left" } },
//       cell: ({ getValue }) => {
//         const value = getValue() || "";
//         const items = value
//           .split(",")
//           .map((item) => item.trim())
//           .filter(Boolean);
//         return (
//           <span>
//             {items.map((item, idx) => (
//               <React.Fragment key={idx}>
//                 {item}
//                 {idx < items.length - 1 && <span>, </span>}
//               </React.Fragment>
//             ))}
//           </span>
//         );
//       },
//     },
//     {
//       id: "qualification_later_name",
//       header: "Qualification Acquired Later",
//       accessorKey: "qualification_later_name",
//       meta: { style: { textAlign: "left" } },
//       cell: ({ getValue }) => {
//         const value = getValue() || "";
//         const items = value
//           .split(",")
//           .map((item) => item.trim())
//           .filter(Boolean);
//         return (
//           <span>
//             {items.map((item, idx) => (
//               <React.Fragment key={idx}>
//                 {item}
//                 {idx < items.length - 1 && <span>, </span>}
//               </React.Fragment>
//             ))}
//           </span>
//         );
//       },
//     },
//     {
//       id: "basic_details",
//       header: "View More Details & Print",
//       cell: ({ row }) => (
//         <button className="btn-basic-details" onClick={() => openBasicDetailsModal(row.original)}>
//           View Details
//         </button>
//       ),
//     },
//     ...(roleIdValue === "4"
//       ? [
//           {
//             id: "approve",
//             header: "Approve",
//             cell: ({ row }) => {
//               const { is_checker_approved, cfms_id } = row.original;

//               if (is_checker_approved) {
//                 return (
//                   <span className="status-badge status-approved">
//                     <FaCheckCircle size={16} />
//                     Approved
//                   </span>
//                 );
//               } else {
//                 return (
//                   <button
//                     className="btn-back-to-maker"
//                     // onClick={() => handleBackToMaker(cfms_id)}
//                   >
//                     Back to Maker
//                   </button>
//                 );
//               }
//             },
//           },
//         ]
//       : []),
//   ];

//   useEffect(() => {
//     GetNonTeachingFacultyData();
//   }, []);



//   return (
//     <>
//       <Modal show={showModal} onHide={() => setShowModal(false)} centered backdrop="static" keyboard={false} animation={false} dialogClassName="modal-xxxl">
//         <Modal.Header closeButton className="faculty-modal-header">
//           <Modal.Title>Non-Teaching Faculty Complete Details</Modal.Title>
//         </Modal.Header>

//         <Modal.Body className="report-modal-body">
//           <div ref={tableRef} className="faculty-report">
//             {/* Personal Details */}
//             <h5 className="report-section">Personal Details</h5>

//             <div className="report-row">
//               <div>
//                 <b>CFMS ID:</b> {modalData?.cfms_id}
//               </div>
//               <div>
//                 <b>Faculty Name:</b> {modalData?.nt_fac_name}
//               </div>
//             </div>

//             <div className="report-row">
//               <div>
//                 <b>Aadhar:</b> {modalData?.masked_aadhar}
//               </div>
//               <div>
//                 <b>Gender:</b> {modalData?.gender}
//               </div>
//             </div>

//             <div className="report-row">
//               <div>
//                 <b>Date of Birth:</b> {modalData?.dob}
//               </div>
//               <div>
//                 <b>Caste:</b> {modalData?.caste}
//               </div>
//             </div>

//             <div className="report-row">
//               <div>
//                 <b>Sub Caste:</b> {modalData?.sub_caste_name}
//               </div>
//               <div>
//                 <b>EWS:</b> {modalData?.ews || "N/A"}
//               </div>
//             </div>

//             <div className="report-row">
//               <div>
//                 <b>Physically Challenged:</b> {modalData?.is_ph ? "Yes" : "No"}
//               </div>
//               <div>
//                 <b>Type of Disability:</b> {modalData?.nt_type_of_disability || "N/A"}
//               </div>
//             </div>

//             <div className="report-row">
//               <div>
//                 <b>Disability Percentage:</b> {modalData?.nt_per_disability || "N/A"}
//               </div>
//               <div>
//                 <b>Local District:</b> {modalData?.dist_name}
//               </div>
//             </div>

//             {/* Appointment Details */}
//             <h5 className="report-section">Appointment Details</h5>

//             <div className="report-row">
//               <div>
//                 <b>Designation:</b> {modalData?.nt_designation}
//               </div>
//               <div>
//                 <b>Designation at time of Appointment:</b> {modalData?.nt_design_time_of_appointment}
//               </div>
//             </div>

//             <div className="report-row">
//               <div>
//                 <b>Date of Joining:</b> {modalData?.doj}
//               </div>
//               <div>
//                 <b>University Type:</b> {modalData?.nt_unv_type}
//               </div>
//             </div>

//             <div className="report-row">
//               <div>
//                 <b>Appointed Category:</b> {modalData?.appoint_cat_name}
//               </div>
//               <div>
//                 <b>University Code:</b> {modalData?.ub_code}
//               </div>
//             </div>

//             {/* Contact Details */}
//             <h5 className="report-section">Contact Details</h5>

//             <div className="report-row">
//               <div>
//                 <b>Mobile Number:</b> {modalData?.contact}
//               </div>
//               <div>
//                 <b>Email:</b> {modalData?.email_id}
//               </div>
//             </div>

//             {/* Qualification */}
//             <h5 className="report-section">Qualification</h5>

//             <div className="report-row">
//               <div>
//                 <b>Qualification at Appointment:</b> {modalData?.qualification_appoint_name}
//               </div>
//               <div>
//                 <b>Qualification Acquired Later:</b> {modalData?.qualification_later_name}
//               </div>
//             </div>

//             {modalData?.nt_qual_appoint_other && (
//               <div className="report-row">
//                 <div>
//                   <b>Other Qualification (Appointment):</b> {modalData?.nt_qual_appoint_other}
//                 </div>
//                 <div>
//                   <b>Other Qualification (Later):</b> {modalData?.nt_qual_later_other || "N/A"}
//                 </div>
//               </div>
//             )}
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <button className="btn btn-primary" onClick={handlePrint}>
//             Print
//           </button>
//           <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
//             Close
//           </button>
//         </Modal.Footer>
//       </Modal>

//       <div className="fac-topbar">
//         <div className="fac-detnew">
//           <h5 className="mb-0 mx-4">{roleIdValue === "4" ? "Non-Teaching Faculty Details Approval Form" : "Non-Teaching Faculty Details Report"}</h5>
//         </div>
//       </div>

     

//       <div className="faculty-form-wrapper">
//         <div className="faculty-card">
//           {nonTeachingFacultyData?.length > 0 ? (
//             <CommonReactTable
//               data={nonTeachingFacultyData}
//               columns={NonTeachingFacultyReportColumns}
//               filename="Non-Teaching Faculty Details Report"
//               headerName={roleIdValue === "4" ? "Non-Teaching Faculty Details Approval" : "Non-Teaching Faculty Details Report"}
//               showPagination={true}
//               showExcel={true}
//               showPrint={true}
//               showFooter={false}
//               excelFileName="Non-Teaching Faculty Details Report"
//             />
//           ) : (
//             <center className="text-danger h5">**** No Data Found ****</center>
//           )}

//           {roleIdValue === "4" && nonTeachingFacultyData?.length > 0 && (
//             <div className="text-end mt-3">
//               <button
//                 type="button"
//                 className="submit-btn btn-sm btn"
//                 style={{ marginBottom: "10px" }}
//                 //  onClick={handleBulkApprove}
//                 disabled={!Object.values(selectedRows).some(Boolean)}
//               >
//                 Approve Selected
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// }


import React, { useState, useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import {
  useRowSelection,
  FacultyDetailsModal,
  FacultyReportLayout,
  selectColumn,
  textColumn,
  dateColumn,
  commaListColumn,
  detailsColumn,
  approveColumn,
} from "./FacultyReport";

export default function NonTeachingFacultyDetailsRepo() {
  const isChecker = sessionStorage.getItem("role_id") === "4";
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: "Non-Teaching Faculty Details",
  });

  const [nonTeachingFacultyData, setNonTeachingFacultyData] = useState([]);
  const [modalData, setModalData] = useState(null);
  const selection = useRowSelection(nonTeachingFacultyData);

  useEffect(() => {
    CommonAxiosGet(`${config.url.FAC_URL}getFacultyDetailsnonteaching`).then((res) => {
      setNonTeachingFacultyData(res?.data?.scode === "01" ? res?.data?.fac_details || [] : []);
    });
  }, []);

  const columns = [
    selectColumn({ isChecker, selection }),
    textColumn("cfms_id", "CFMS ID", { alignLeft: false }),
    textColumn("nt_fac_name", "Faculty Name"),
    textColumn("masked_aadhar", "Adhaar No"),
    textColumn("gender", "Gender", { alignLeft: false }),
    dateColumn("dob", "Date of Birth"),
    textColumn("nt_designation", "Designation"),
    dateColumn("doj", "Date of Joining in the University"),
    textColumn("nt_unv_type", "University Type"),
    textColumn("appoint_cat_name", "Appointed Category"),
    textColumn("nt_design_time_of_appointment", "Designation at the time of Appointment"),
    commaListColumn("qualification_appoint_name", "Qualifications at the Time of Appointment"),
    commaListColumn("qualification_later_name", "Qualification Acquired Later"),
    detailsColumn(setModalData),
    // pass a handler here once the send-back endpoint is ready: approveColumn(handleSendBack)
    ...(isChecker ? [approveColumn()] : []),
  ];

  const m = modalData || {};
  const sections = [
    {
      title: "Personal Details",
      rows: [
        [["CFMS ID", m.cfms_id], ["Faculty Name", m.nt_fac_name]],
        [["Aadhar", m.masked_aadhar], ["Gender", m.gender]],
        [["Date of Birth", m.dob], ["Caste", m.caste]],
        [["Sub Caste", m.sub_caste_name], ["EWS", m.ews || "N/A"]],
        [["Physically Challenged", m.is_ph ? "Yes" : "No"], ["Type of Disability", m.nt_type_of_disability || "N/A"]],
        [["Disability Percentage", m.nt_per_disability || "N/A"], ["Local District", m.dist_name]],
      ],
    },
    {
      title: "Appointment Details",
      rows: [
        [["Designation", m.nt_designation], ["Designation at time of Appointment", m.nt_design_time_of_appointment]],
        [["Date of Joining", m.doj], ["University Type", m.nt_unv_type]],
        [["Appointed Category", m.appoint_cat_name], ["University Code", m.ub_code]],
      ],
    },
    {
      title: "Contact Details",
      rows: [[["Mobile Number", m.contact], ["Email", m.email_id]]],
    },
    {
      title: "Qualification",
      rows: [
        [
          ["Qualification at Appointment", m.qualification_appoint_name],
          ["Qualification Acquired Later", m.qualification_later_name],
        ],
        ...(m.nt_qual_appoint_other
          ? [
              [
                ["Other Qualification (Appointment)", m.nt_qual_appoint_other],
                ["Other Qualification (Later)", m.nt_qual_later_other || "N/A"],
              ],
            ]
          : []),
      ],
    },
  ];

  return (
    <>
      <FacultyDetailsModal
        show={!!modalData}
        onHide={() => setModalData(null)}
        title="Non-Teaching Faculty Complete Details"
        sections={sections}
        printRef={printRef}
        onPrint={handlePrint}
      />

      <FacultyReportLayout
        title={isChecker ? "Non-Teaching Faculty Details Approval Form" : "Non-Teaching Faculty Details Report"}
        data={nonTeachingFacultyData}
        columns={columns}
        isChecker={isChecker}
        hasSelection={selection.hasSelection}
        // onBulkApprove={handleBulkApprove}
      />
    </>
  );
}